module.exports = __webpack_public_path__ + "img/clapping_hands.78f43824.gif";